import React from 'react';

interface LoadingOverlayProps {
  isVisible: boolean;
  text?: string;
  primaryColor?:any;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  text = 'Loading...',
  primaryColor,
}) => {
  if (!isVisible) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="loading-text">{text}</div>

        <div className="loading-line">
          <div className="loading-line-move" />
        </div>
      </div>

      <style>{`
        .loading-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.35);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .loading-content {
          width: 220px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .loading-text {
          color: ${primaryColor};
          font-size: 20px;
          font-weight: 800;
          margin-bottom: 10px;
        }

        .loading-line {
          position: relative;
          width: 280px;
          height: 3px;
          background: rgba(255, 255, 255, 0.25);
          border-radius: 10px;
          overflow: hidden;
        }

        .loading-line-move {
          position: absolute;
          top: 0;
          left: 0;
          width: 100px;
          height: 100%;
          background: ${primaryColor};
          border-radius: 10px;
          animation: loading-slide 1.4s ease-in-out infinite;
        }

        @keyframes loading-slide {
          0% {
            left: 0;
          }

          50% {
            left: calc(100% - 60px);
          }

          100% {
            left: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingOverlay;